import React, {FC} from "react"
import QRCode from "qrcode.react"

import Flex from "@irati/ui/src/Flex"
import {Body, H1} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage from "@irati/utils/lang"
import {getDomain} from "@irati/utils/links"

interface Props {
  text: string
}

const UsePerkboxAppBanner: FC<Props> = ({text}) => {
  const theme = useTheme()
  const utmSource = "wellness"
  const utmMedium = "qr_code"
  const qrCode = `${getDomain("app")}/wellness?redirectToAppStore=true&utm_source=${utmSource}&utm_medium=${utmMedium}`

  return (
    <Flex marginTop={3} marginBottom={3} width="100%" justifyContent="space-between" gap={1}>
      <div>
        <H1 color={theme.colors.primary2} maxWidth="100%" marginBottom>
          <FormattedMessage
            id="platform.usePerkboxAppBanner.title"
            values={{
              app: (
                <H1 color={theme.colors.utility.success} display="inline">
                  <FormattedMessage id="platform.usePerkboxAppBanner.app" />
                </H1>
              ),
              text: (
                <H1 color={theme.colors.utility.success} display="inline">
                  <FormattedMessage id={text} />
                </H1>
              )
            }}
          />
        </H1>
        <Body large color={theme.colors.primary2} maxWidth="100%">
          <FormattedMessage id="platform.usePerkboxAppBanner.body" />
        </Body>
      </div>
      <QRCode value={qrCode} size={90} />
    </Flex>
  )
}

export default UsePerkboxAppBanner
